module.exports = __webpack_public_path__ + "static/media/sdworx_logo.006f6d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/sdworx_logo.png
// module id = 306
// module chunks = 0